// Import utils
import { getDocumentElements, getDocumentElement, updateFieldTotal } from "../../Utils/Utils";

/**
 * Callback function to execute when mutations are observed. This will
 * only fire the calculation if we notice a change in the childlist nodes.
 * 
 * @param       {array}     mutationList
 * 
 * @returns     {void}
 */
const OtherWaterUseCalcChildNodeObserver = (mutationList) => {
    mutationList.forEach(mutation => {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // Use setTimeout to ensure DOM is fully updated
            setTimeout(() => {
                OtherWaterUseCalc(true);
            }, 100);
        }
    });
};

/**
 * Set the childlist mutation observer.
 * 
 * @returns     {void}
 */
const SetOtherWaterUseCalcMutationObserver = () => {
    const Accordion = getDocumentElement('#other');
    const ObserverConfig = { childList: true, subtree: true };

    const Observer = new MutationObserver(OtherWaterUseCalcChildNodeObserver);
    Observer.observe(Accordion, ObserverConfig);
};

/**
 * This watches the sub total fields for value changes. It calls for an update
 * on the total water use. If we have already mounted the eventlisteners, ignore
 * the mutationobserver setup.
 * 
 * @param       {boolean}   mounted
 * 
 * @returns     {void}
 */
export const OtherWaterUseCalc = (mounted) => {
    const OtherMegaLTotalField = getDocumentElement('#otherTotal');
    const OtherMegaLSummaryTotalField = getDocumentElement('#tot_other');

    if (OtherMegaLTotalField) {
        if (mounted === false) {
            SetOtherWaterUseCalcMutationObserver();
        }

        // Always get fresh field references to include newly cloned elements
        const OtherMegaLFields = getDocumentElements('input[name^="otherSubtotal"]');
        
        if (OtherMegaLFields) {
            OtherMegaLFields.forEach(field => {
                // Remove existing listeners to prevent duplicates
                field.removeEventListener('input', field._otherWaterUseHandler);
                
                // Create new handler function and store reference
                field._otherWaterUseHandler = (e) => {
                    e.stopImmediatePropagation();
                    // Get fresh field references for the calculation
                    const currentFields = getDocumentElements('input[name^="otherSubtotal"]');
                    updateFieldTotal(currentFields, OtherMegaLTotalField, OtherMegaLSummaryTotalField);
                };
                
                field.addEventListener('input', field._otherWaterUseHandler);
            });
        }
    }

    // listen for clone removed and re-update totals
    document.addEventListener('clonable:removed', e => {
        if (e.detail.id === 'other') {
            // Get fresh field references for the calculation
            const currentFields = getDocumentElements('input[name^="otherSubtotal"]');
            updateFieldTotal(currentFields, OtherMegaLTotalField, OtherMegaLSummaryTotalField);
        }
    });

    // Listen for when new "other" categories are added - use more specific selector
    document.addEventListener('click', e => {
        // Check if clicked element is the "Add other" button within the other section
        if (e.target.textContent?.includes('Add other') || 
            (e.target.classList.contains('farm-calc-accordion__action--add') && 
             e.target.closest('[data-id="other"]'))) {
            // Use setTimeout to wait for DOM to update after clone is added
            setTimeout(() => {
                OtherWaterUseCalc(true); // Re-run with mounted=true to skip mutation observer setup
            }, 200);
        }
    });
};
